





















































































import { Component, Vue } from "vue-property-decorator";
import Layout from "@/components/Layout.vue"; // @ is an alias to /src
import AssignCard from "@/components/common/AssignCard.vue";
import WordOnPic from "@/components/common/WordOnPic.vue";
import MainSlogan from "@/components/common/MainSlogan.vue";

@Component({
  components: {
    Layout,
    AssignCard,
    WordOnPic,
    MainSlogan,
  },
})
export default class ZCParkSolar extends Vue {}
